import React from 'react';
import { useRoute, RouteProp } from '@react-navigation/native';

import { ScheduleStackParamList } from '@/types/navigation';
import { TimeOffAssembleView } from './AssembleTimeOffScreen';

type DetailRoute = RouteProp<ScheduleStackParamList, 'TimeOffDetail'>;

/**
 * A submitted/approved request: dates, notes, and the event list with coverage
 * chips + gap highlight. Reuses the assemble body without the submit/class-edit
 * affordances. The requester or a manager can still change subs while the request
 * is live (late-subs: today like future; past ≤31 days = managers "record"); anyone
 * else (e.g. the sub) sees it read-only. No approve/deny here.
 */
const TimeOffDetailScreen: React.FC = () => {
  const route = useRoute<DetailRoute>();
  return <TimeOffAssembleView requestId={route.params.requestId} readOnly />;
};

export default TimeOffDetailScreen;
